var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRepurpose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "repurpose_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680 0v6851H0V0h1680z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "repurpose_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.452 12.768l-.816 1.318c-4.507 7.279-3.464 16.57 2.535 22.597.973.976 1.864 1.729 2.753 2.319l1.639-3.36 7.011 10.601L8.994 47l1.75-3.587a18.968 18.968 0 01-4.022-3.317c-6.94-6.97-8.703-17.65-4.366-26.55l.204-.42 5.892-.358zm34.611 1.008L50 24.381l-3.997.21a19.618 19.618 0 01-.235 2.68c-.735 4.859-2.97 9.286-6.463 12.792A22.97 22.97 0 0124.55 46.8l-.454.03-3.327-4.878 1.577.054c5.029.151 9.938-1.77 13.475-5.322a18.127 18.127 0 004.961-9.4c.15-.684.235-1.415.267-2.31l-3.7.206 5.714-11.403zM10.038 0l2.182 3.321C21.1-1.396 32.135.216 39.302 7.36c1.15 1.154 2.116 2.331 2.873 3.5l.251.388-2.667 5.27-.722-1.355c-.832-1.559-1.884-2.967-3.216-4.305-5.52-5.545-14-6.89-20.894-3.405l2.04 3.143-12.58.756L10.039 0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#repurpose_svg__a)",
    transform: "translate(-817 -2544)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#repurpose_svg__b)",
    transform: "translate(817 2544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v47H0V0z"
  })))));
}

export default SvgRepurpose;